<h2 mat-dialog-title class="cdk-visually-hidden">
  Email Preview: {{ data.subject }}
</h2>
<div class="content" fxLayout="column">
  <div class="message-preview-header">
    @if (loaded) {
      <div class="message-metadata">
        <div fxLayout="row" class="subject" fxLayoutGap="10px">
          <div
            fxLayout="row"
            fxFlex="50px"
            class="subject-title"
            fxLayoutAlign="end"
          >
            Subject:
          </div>
          <div fxLayout="row" fxFlex>
            <b [innerHTML]="data.subject | safeHtml"></b>
          </div>
        </div>
        <div fxLayout="row" class="subject" fxLayoutGap="10px">
          <div
            fxLayout="row"
            fxFlex="50px"
            class="subject-title"
            fxLayoutAlign="end"
          >
            From:
          </div>
          <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="5px">
            <div fxLayout="row">
              <b>{{ data.senderName }}</b>
            </div>
            <div fxLayout="row" fxLayoutAlign="start">
              &lt;{{ data.sender }}&gt;
            </div>
          </div>
        </div>
        @if (data.replyTo) {
          <div fxLayout="row" class="subject" fxLayoutGap="10px">
            <div
              fxLayout="row"
              fxFlex="50px"
              class="subject-title"
              fxLayoutAlign="end"
            >
              Reply To:
            </div>
            <div fxLayout="row" fxFlex>{{ data.replyTo }}</div>
          </div>
        }
        @if (data.bccAddresses && data.bccAddresses.length > 0) {
          <div fxLayout="row" class="subject" fxLayoutGap="10px">
            <div
              fxLayout="row"
              fxFlex="50px"
              class="subject-title"
              fxLayoutAlign="end"
            >
              BCC:
            </div>
            <div fxLayout="row" fxFlex>{{ data.bccAddresses[0] }}</div>
          </div>
        }
      </div>
    }
    <button
      mat-icon-button
      class="close"
      (click)="close()"
      aria-label="Close preview email"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div
    class="container"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="{ 'background-color': loaded ? 'white' : '' }"
  >
    @if (!(failed$ | async) && loaded == false) {
      <div class="loading" role="status">
        <img src="../assets/img/Lineup-Logo-black.svg" alt="" />
        <p>Loading...</p>
      </div>
    }
    @if (!(failed$ | async)) {
      <div fxFlex class="iframe-container">
        <iframe
          sandbox="allow-same-origin"
          title="Email Content"
          width="100%"
          #iframe
        ></iframe>
      </div>
    } @else {
      <div class="failed">
        <h3>Content is not available</h3>
      </div>
    }
  </div>
</div>
